<template>
  <v-container fluid class="mt-5">
    <div class="d-flex justify-center text-h4 mb-10">Блог</div>
    <!-- <v-row>
      <v-col
        v-for="(post, idx) in posts"
        :key="post.id"
        :to="`/posts/${post.id}`"
        :class="postClass(idx)"
      >
        <v-card class="rounded-xl">
          <div class="d-flex flex-wrap">
            <div>
              <v-card-title
                class="text-h4 mb-4"
                v-text="post.title"
              ></v-card-title>

              <v-card-subtitle
                v-html="post.content.slice(0, 150) + '...'"
              ></v-card-subtitle>

              <v-card-actions>
                <v-btn class="ml-2 mt-5" small> Читать полностью > </v-btn>
              </v-card-actions>
            </div>
            <v-img :src="post.image" height="250px" width="150px"> </v-img>
          </div>
        </v-card>
      </v-col>
    </v-row> -->
    <div class="d-flex justify-center rounded-xl">
      <v-col :cols="this.columns">
        <v-card class="rounded-xl mb-10" id="my_article"></v-card>
        <script type="application/javascript">
          VK.Widgets.Article(
            "my_article",
            "@universtat-kto-ya-i-chem-mogu-byt-vam-poleznoi"
          );
        </script>
        <v-card class="rounded-xl mb-10" id="my_article2"></v-card>
        <script type="application/javascript">
          VK.Widgets.Article(
            "my_article2",
            "@universtat-chto-vy-poluchite-priobretaya-dostup-k-servisu-statistiki"
          );
        </script>
        <v-card
          v-for="post in posts"
          :key="post.id"
          class="mb-10 rounded-xl"
          min-width="300px"
          color="grey lighten-5"
          :to="`/posts/${post.id}`"
        >
          <v-img :src="post.image" height="300px" max-height="300px"></v-img>

          <v-avatar v-if="post.image" :src="post.image"></v-avatar>
          <v-card-title class="title">
            {{ post.title }}
          </v-card-title>
          <v-card-text>
            {{ post.title }}
          </v-card-text>

          <v-card-actions>
            <v-btn text class="text-none"> Читать </v-btn>
            <v-spacer></v-spacer>
            <v-btn icon text :ripple="false">
              <v-icon color="red lighten-2">mdi-heart</v-icon>
            </v-btn>
            <v-btn icon>
              <v-icon color="blue lighten-2">mdi-share-variant</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </div>
  </v-container>
</template>

<script>
import openapi from "../config/openapi";

export default {
  computed: {
    columns() {
      console.log(this.$vuetify.breakpoint.name);
      var br_name = this.$vuetify.breakpoint.name;
      switch (br_name) {
        case "xs":
          return 12;
        case "sm":
          return 12;
        case "md":
          return 10;
        case "lg":
          return 6;
        case "xl":
          return 6;
        default:
          return 6;
      }
    },
  },
  data: () => ({
    url: "/api/v1/posts/",
    posts: [],
  }),

  methods: {
    cols: function () {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 8;
        case "sm":
          return 4;
        case "md":
          return 8;
        case "lg":
          return 6;
        case "xl":
          return 6;
      }
      return;
    },
    getPosts: function () {
      openapi
        .get(this.url)
        .then((response) => {
          this.posts = response.data.results.reverse();
          //   console.log(response);
          // console.log(JSON.stringify(this.posts));
        })
        .catch((error) => {
          console.log(error.data);
        });
    },
    postClass: function (idx) {
      if (idx == 0) {
        return "col-md-6 col-lg-12";
      } else {
        return "col-md-6 col-lg-4";
      }
    },
  },

  created() {
    this.getPosts();

    // for (var post of this.posts) {
    // }
  },
  mounted() {
    let post = document.getElementById("vk_article_-26284064_15959");
    post.setAttribute("src", "https://vk.com/js/api/openapi.js?169");
    document.head.appendChild(post);
  },
};
</script>

<style scoped>
.v-avatar .v-icon,
.v-avatar .v-image,
.v-avatar .v-responsive__content,
.v-avatar img,
.v-avatar svg {
  border-radius: 25px 0 0 25px !important;
}
.line {
  position: absolute;
  top: 30%;
  left: 10%;
  width: 100%;
  height: 3px;
  color: black;
}
.v-application .text-h4,
.v-application .text-h2 {
  font-family: "Cuprum", sans-serif !important;
}
</style>
